module.exports = __webpack_public_path__ + "img/OV.d37e5cdd.png";